// export default function HeroSection() {
//   return (
//     <section className="flex flex-col md:flex-row items-center gap-6 p-6 md:p-12">
//       <img
//         src="/profile_image.jpg"
//         alt="Pranjal Varade"
//         height="20%"
//         //className="w-24 h-24 rounded-full shadow-lg"
//         className="rounded-full aspect-square  object-cover"
//         // alt="Circular image"
//       />
//       <div>
//         <h1 className="text-3xl font-bold">Hi, I’m Pranjal</h1>
//         <p className="text-lg text-gray-600 mt-2">
//           Hi, I’m Pranjal — a full stack developer who’s always been drawn to
//           the frontend side of things. I enjoy building clean, intuitive, and
//           fast user interfaces that make people’s lives easier. I'm most
//           comfortable working with React, Node.js, GraphQL, and AWS—but more
//           than tools, I care about writing code that’s maintainable, scalable,
//           and makes sense to the team.
//         </p>
//         <p className="text-sm text-gray-500 mt-1">
//           Based in the U.S. — exploring roles in Germany & beyond
//         </p>
//         <div className="flex gap-4 mt-4">
//           <a
//             href="https://github.com/PranjalVarade"
//             className="underline text-blue-500"
//           >
//             GitHub
//           </a>
//           <a
//             href="https://www.linkedin.com/in/pranjal-varade/"
//             className="underline text-blue-500"
//           >
//             LinkedIn
//           </a>
//           <a
//             href="/Pranjal_Varade_Resume.pdf"
//             className="underline text-blue-500"
//           >
//             Resume
//           </a>
//         </div>
//       </div>
//     </section>
//   );
// }
export default function HeroSection() {
  return (
    // <section className="flex flex-col-reverse md:flex-row items-center gap-6 p-6 md:p-12">
    // <section
    //   id=""
    //   className="flex flex-col md:flex-row items-center justify-center gap-8 mt-12 bg-text-primary bg-primary dark:bg-neutral-900/80 border-primary/30 dark:border-primary/50 shadow-md"
    // >
    // <section className="flex flex-col-reverse  items-center justify-center gap-8 lg:mt-0 md:mt-16 bg-text-primary bg-primary dark:bg-neutral-900/80 border-primary/30 dark:border-primary/50 shadow-md">
    //   <div className="text-center md:text-left text-lg  dark:text-white mb-4 leading-relaxed pt-10">
    <section
      id="resume"
      className="flex flex-col md:flex-row items-center justify-center gap-8 mt-12 bg-text-primary bg-text-primary bg-primary dark:bg-neutral-900/80 border-primary/30 dark:border-primary/50 "
    >
      <div className="text-center md:text-left text-lg text-white mb-4 leading-relaxed pt-10 md:pt-20">
        <h1 className="text-4xl font-bold">👋 Hi, I’m Pranjal</h1>
        <p className="text-lg mt-2 dark:text-white">
          Full Stack Developer focused on writing clean code that solves real
          problems.
        </p>
        {/* <p className="text-sm text-gray-500 mt-1">
          Based in the U.S. • Exploring opportunities in Germany & beyond
        </p> */}

        <div className="mt-4 flex justify-center md:justify-start gap-4">
          <a
            href="https://www.linkedin.com/in/pranjal-varade/"
            target="_blank"
            // className="text-blue-500 underline"
            className="px-4 py-2 rounded-full border text-sm font-medium transition hover:bg-white hover:text-primary"
          >
            LinkedIn
          </a>
          <a
            href="/Pranjal_Varade_Resume.pdf"
            target="_blank"
            //className="text-blue-500 underline"
            className="px-4 py-2 rounded-full border text-sm font-medium transition hover:bg-white hover:text-primary"
          >
            Resume
          </a>
          <a
            //href="https://github.com/PranjalVarade"
            href="https://github.com/Pranjal-Varade97"
            target="_blank"
            //className="text-blue-500 underline"
            className="px-4 py-2 rounded-full border text-sm font-medium transition hover:bg-white hover:text-primary"
          >
            GitHub
          </a>
        </div>
      </div>
      <div className="pb-10">
        <img
          src="/profile_image.png"
          alt="Pranjal Varade"
          className="w-36 h-36 rounded-full shadow-lg object-cover sm:mt-10 "
        />
      </div>
    </section>
  );
}
